// Unlock CTA card with optional value-framing headline (Phase 2.5 / C1
// experiment arm). Extracted verbatim from AuditPreview.jsx (W2b). The
// `assignedVariant` lands on the card root as a `data-arm` attribute so
// downstream funnel queries don't have to change.
export default function PreviewUnlockCTA({
  headline,
  assignedVariant,
  error,
  unlocking,
  onUnlock,
}) {
  return (
    <div
      className="sf-card"
      data-testid="preview-unlock-card"
      data-arm={assignedVariant}
      style={{ borderColor: "var(--sf-gold-dim)" }}
    >
      {headline.visible && (
        <div
          data-testid="preview-value-headline"
          style={{ marginBottom: 22, paddingBottom: 18, borderBottom: "1px solid #22262B" }}
        >
          <div
            className="sf-display"
            style={{
              fontFamily: "var(--sf-display, 'Bricolage Grotesque', serif)",
              fontSize: 26,
              lineHeight: 1.25,
              color: "var(--sf-offwhite)",
            }}
          >
            Recover{" "}
            {headline.mode === "range" ? (
              <span
                className="sf-mono"
                style={{ color: "var(--sf-gold)", fontSize: 30, letterSpacing: "-0.01em" }}
                data-testid="preview-value-headline-amount"
              >
                ${headline.min.toLocaleString("en-US")}–${headline.max.toLocaleString("en-US")}/mo
              </span>
            ) : (
              <>
                up to{" "}
                <span
                  className="sf-mono"
                  style={{ color: "var(--sf-gold)", fontSize: 30, letterSpacing: "-0.01em" }}
                  data-testid="preview-value-headline-amount"
                >
                  ${headline.max.toLocaleString("en-US")}/mo
                </span>
              </>
            )}{" "}
            in hidden revenue leaks.
          </div>
        </div>
      )}
      <div className="sf-eyebrow" style={{ marginBottom: 8 }}>Get the full audit</div>
      <h3 className="sf-display" style={{ fontSize: 22, marginBottom: 12 }}>What you walk away with</h3>
      <ul
        data-testid="preview-unlock-outcomes"
        style={{ listStyle: "none", margin: "0 0 18px 0", padding: 0, display: "grid", gap: 10 }}
      >
        <li style={{ color: "var(--sf-offwhite)", fontSize: 14, lineHeight: 1.5 }}>
          <span className="sf-gold sf-mono" style={{ marginRight: 8 }}>→</span>
          The full breakdown behind your Business Health score
        </li>
        <li style={{ color: "var(--sf-offwhite)", fontSize: 14, lineHeight: 1.5 }}>
          <span className="sf-gold sf-mono" style={{ marginRight: 8 }}>→</span>
          The revenue and system gaps affecting growth, named and quantified
        </li>
        <li style={{ color: "var(--sf-offwhite)", fontSize: 14, lineHeight: 1.5 }}>
          <span className="sf-gold sf-mono" style={{ marginRight: 8 }}>→</span>
          Prioritized next steps in a 90-day action plan
        </li>
        <li style={{ color: "var(--sf-offwhite)", fontSize: 14, lineHeight: 1.5 }}>
          <span className="sf-gold sf-mono" style={{ marginRight: 8 }}>→</span>
          A branded PDF report you can hand to your team
        </li>
        <li style={{ color: "var(--sf-offwhite)", fontSize: 14, lineHeight: 1.5 }}>
          <span className="sf-gold sf-mono" style={{ marginRight: 8 }}>→</span>
          Clarity on what to fix first
        </li>
      </ul>
      {error && (
        <div className="sf-mono" style={{ color: "#e2867e", fontSize: 13, marginBottom: 12 }} data-testid="preview-unlock-error">
          {error}
        </div>
      )}
      <button
        className="sf-btn"
        onClick={onUnlock}
        disabled={unlocking}
        data-testid="preview-unlock-btn"
      >
        {unlocking ? "Redirecting to Stripe…" : "Get the full audit — $97"}
      </button>
      <div className="sf-mono sf-muted-text" style={{ marginTop: 10, fontSize: 12 }}>
        Secure checkout via Stripe. Test mode active.
      </div>
    </div>
  );
}
